import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { ArchiveV3RedirectGuard } from 'src/app/shared/guards/archive-v3-redirect.guard';
import { RoleGuard } from 'src/app/shared/guards/role.guard';
import { ARCHIVE_V3_GENERAL_SEARCH } from 'src/app/shared/utils/archive-v3-redirect.utils';
// Custom packages - Component
import { SearchDocsListV2Component } from 'src/app/modules/search-docs/pages/search-docs-listv2/search-docs-listv2.page';
var ɵ0 = {
    permissions: ['canReadDocumentsList'],
    archiveV3Redirect: ARCHIVE_V3_GENERAL_SEARCH,
}, ɵ1 = function () {
    return import("./pages/search-docs-listv3/search-docs-listv3.module.ngfactory").then(function (m) { return m.SearchDocsListV3ModuleNgFactory; });
}, ɵ2 = {
    permissions: ['canReadDocumentsList']
};
var routes = [
    // {
    //   path: 'list',
    //   component: SearchDocsListComponent,
    //   canActivate: [RoleGuard],
    //   data: {
    //     permissions: ['canReadDocumentsList']
    //   },
    // },
    {
        // Opens listv3 instead once the 3.0.0 archive is live (FE-A1, ArchiveV3RedirectGuard)
        path: 'listv2',
        component: SearchDocsListV2Component,
        canActivate: [ArchiveV3RedirectGuard, RoleGuard],
        data: ɵ0,
    },
    {
        // The general search on the new archive. Reachable by URL only until the switch: the side menu
        // and the home still point to listv2. Same permission as listv2, the one the back-end asks.
        // Loaded on its own (SearchDocsListV3Module), out of the initial bundle: this module is also
        // imported by AppModule.
        path: 'listv3',
        loadChildren: ɵ1,
        canActivate: [RoleGuard],
        data: ɵ2,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var SearchDocsRoutingModule = /** @class */ (function () {
    function SearchDocsRoutingModule() {
    }
    return SearchDocsRoutingModule;
}());
export { SearchDocsRoutingModule };
export { ɵ0, ɵ1, ɵ2 };
